import { render } from "./GroupSelector.vue?vue&type=template&id=b582ed10&scoped=true"
import script from "./GroupSelector.vue?vue&type=script&lang=js"
export * from "./GroupSelector.vue?vue&type=script&lang=js"

import "./GroupSelector.vue?vue&type=style&index=0&id=b582ed10&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b582ed10"]])

export default __exports__